module.exports = __webpack_public_path__ + "img/trendmanager-logo.146d7cd3.svg";